<template>
    <div v-if="displayMode == 'Tall'">
        <div class="row subscribe-callout my-5 mx-2 mx-lg-4 pb-3">
            <div v-if="!formSuccess" class="col-12 text-center text-is-blue subscribe-callout-sign-in pr-1 pb-2 pt-4 pt-md-2 pt-lg-4">
                <p class="heading-2">{{ title }}</p>
            </div>
            <div v-if="!formSuccess && subtitle != ''" class="col-12 text-center fw-normal subscribe-callout-sign-in pr-1 pb-2 pt-4 pt-md-2 pt-lg-4">
                <p class="heading-4">{{ subtitle }}</p>
            </div>

            <div v-if="!formSuccess" class="col-12 subscribe-callout-email pr-lg-5 pt-2 pt-md-4 pb-2 m-auto text-center text-md-left d-md-flex">
                <input aria-label="Email address field" v-model="emailAddress" class="subscribe-callout-email-input mr-md-3" type="email" :placeholder="getText('hl-subscribe-emailplaceholder')" />
                <input type="submit" class="hl-button subscribe-callout-submit" :value="getText('hl-subscribe-subscribebuttontext')" aria-label="Submit email and Subscribe to the e-newsletter" @click.prevent="submitForm" />
            </div>

            <div class="col-12" v-if="formError">
                <p class="error mb-3 text-center"><slot name="hl-subscribe-invalidemailerror"></slot></p>
            </div>
            <div class="col-12" v-if="formSuccess">
                <h3 class="heading-3 text-center contact-form-success-header mt-3 mb-0"><slot name="hl-subscribe-successtitle"></slot></h3>
                <div class="text-center contact-form-success-message mb-2">{{responseMessage}}</div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="row subscribe-callout my-5 mx-2 mx-lg-4 pb-3">
            <div v-if="!formSuccess" class="col-12 col-md-4 text-center text-md-right subscribe-callout-sign-in pr-1 pb-2 pt-4 pt-md-2 pt-lg-4">
                <p class="heading-2">{{ title }}</p>
            </div>
            <div v-if="!formSuccess" class="col-12 col-md-8 subscribe-callout-email pr-lg-5 pt-2 pt-md-4 pb-2 m-auto text-center text-md-left d-md-flex">
                <input aria-label="Email address field" v-model="emailAddress" class="subscribe-callout-email-input mr-md-3" type="email" :placeholder="getText('hl-subscribe-emailplaceholder')" />
                <input type="submit" class="hl-button subscribe-callout-submit" :value="getText('hl-subscribe-subscribebuttontext')" aria-label="Submit email and Subscribe to the e-newsletter" @click.prevent="submitForm" />
            </div>

            <div class="col-12" v-if="formError">
                <p class="error mb-3 text-center"><slot name="hl-subscribe-invalidemailerror"></slot></p>
            </div>
            <div class="col-12" v-if="formSuccess">
                <h3 class="heading-3 text-center contact-form-success-header mt-3 mb-0"><slot name="hl-subscribe-successtitle"></slot></h3>
                <div class="text-center contact-form-success-message mb-2">{{responseMessage}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:
        {
            title: String,
            subtitle: String,
            displayMode: String,
            cultureCode: String
        },
        data() {
            return {
                emailAddress: "",
                formError: false,
                formSuccess: false,
                errorMessage: "",
                responseMessage: ""
            }
        },
        methods: {
            getText(key) {
                return this.$slots[key][0].text.trim();
            },
            submitForm() {
                this.$axios(
                    {
                        url: this.cultureCode.toLowerCase() + "/signup",
                        data: { email: this.emailAddress },
                        headers: { 'Content-Type': 'application/json' },
                        method: "post"
                    })
                    .then((response) => {
                        console.log(response);

                        if (response.data.IsSuccessStatusCode === false || !response.data.message) {
                            this.formError = true;
                            this.formSuccess = false;
                        } else {
                            this.responseMessage = response.data.message;
                            this.formSuccess = true;
                            this.formError = false;
                        }


                    }).catch((error) => {
                        this.formError = true;
                        this.formSuccess = false;
                    });
            }
        }
    }
</script>

<style lang="scss">
    .subscribe-callout {
        border-top: 1px solid #d8d8d8;
        border-bottom: 1px solid #d8d8d8;

        .error {
            color: $red;
        }

        .text-is-blue {
            color: darkblue;
        }

        .fw-normal {
            font-weight: normal;
        }

        .heading-2 {
            font-size: rem(28);
            margin-bottom: rem(0);
        }

        .subscribe-callout-submit {
            width: 60%;
            margin-top: rem(14);

            @include respond-above(lg) {
                width: 30%;
                margin-top: 0;
            }

            @include respond-below(sm) {
                width: 100%;
            }

            min-width: 150px;
        }

        .subscribe-callout-email {

            .subscribe-callout-email-input {
                width: 60%;
                padding: 0rem 0rem 0rem 1rem;
                height: 50px;
                font-size: rem(14);

                @include respond-above(lg) {
                    padding: 0.5rem 2.0rem;
                    width: 70%;
                }

                @include respond-below(sm) {
                    width: 100%;
                }
            }

            p {
                display: inline-block;
                vertical-align: top;
            }
        }

        .hl-button {
            background-color: $navyBlue;
            color: $white !important;
            transition: all 0.25s;
            display: inline-block;
            text-align: center;
            height: 50px;

            &:hover {
                text-decoration: none;
                background-color: $orangeText;
                color: $navyBlue !important;
            }

            @include respond-above(lg) {
                padding: 0.5rem 3.5rem;
            }
        }
    }
</style>
